export default __webpack_public_path__ + "static/media/elementaltorment.ddc3a983.png";